import { render, staticRenderFns } from "./lesson-header.vue?vue&type=template&id=ea709522&scoped=true"
import script from "./lesson-header.vue?vue&type=script&lang=js"
export * from "./lesson-header.vue?vue&type=script&lang=js"
import style0 from "./lesson-header.vue?vue&type=style&index=0&id=ea709522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea709522",
  null
  
)

export default component.exports